import { useLocation } from 'react-router-dom';

const useCurrentSection = () => {
  const { pathname } = useLocation();
  const path = pathname.split('/');
  const currentSection = path[4];

  return currentSection;
};

export default useCurrentSection;
